import { Moon } from 'lucide-react';

export const FooterBrand = () => (
<div>
              <h3 className="text-2xl font-bold text-red-600 mb-6 flex items-center">
                <Moon className="w-8 h-8 mr-3" />
                Maître Diamma
              </h3>
              <p className="text-gray-400 leading-relaxed mb-4">
                Grand <strong className="text-white">marabout sorcier vaudou</strong> reconnu en Guadeloupe. 
                Spécialiste du <strong className="text-red-400">retour affectif rapide</strong>, rituels de magie blanche, 
                magie rouge, magie noire, désenvoutement et voyance. Plus de 20 ans d'expérience et 280 clients satisfaits.
              </p>
            </div>
);
